import React, { Component } from 'react';
import { Edit, TabbedForm } from 'react-admin';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import CustomFormTab from '../../../Common/Actions/CustomFormTab';
import FiltersTab from './Partials/FiltersTab';
import FlightsTab from './Partials/FlightsTab';
import SettingsTab from './Partials/SettingsTab';
import UserFreqCap from '../../../Common/Partials/UserFreqCap';

import * as AccessCheck from '../../../Common/Utils/AccessCheck';
import PermissionToolbar from '../../../Common/Toolbar';
import PmpTitleName from './StaticData/TitleName';
import RequiredRole from './StaticData/RequiredRole';
import Title from '../../../Common/Title';

import FiltersData from '../../../Common/Partials/Helpers/TabData/Filters';
import FlightsData from '../../../Common/Partials/Helpers/TabData/Flights';
import SettingsTabData from '../../../Common/Partials/Helpers/TabData/SettingsTabData';
import UserFreqCapsData from '../../../Common/Partials/Helpers/TabData/UserFreqCaps';

type Props = {
  basePath: string,
  dispatch: any,
  formValues: any,
  permissions: any,
  record: any,
  resource: string
};

class CampaignPmpEdit extends Component<Props> {
  render() {
    const { formValues, dispatch, ...otherProps } = this.props;

    return (
      <Edit title={<Title title={PmpTitleName} record={this.props.record} />} actions={null} {...otherProps}>
        <TabbedForm toolbar={<PermissionToolbar accessCheck={AccessCheck.Edit(this.props.permissions, RequiredRole)} basePath={this.props.basePath} record={this.props.record} resource={this.props.resource} />} redirect="edit">
          <CustomFormTab
            basePath={this.props.basePath}
            label={<> Settings <SettingsTabData values={this.props.formValues} /> </>}
            record={this.props.record}
            resource={this.props.resource}
          >
            <SettingsTab
              permissions={this.props.permissions}
              record={this.props.record}
              resource={this.props.resource}
            />
          </CustomFormTab>
          <CustomFormTab
            basePath={this.props.basePath}
            label={<> Filters <FiltersData values={this.props.formValues} /> </>}
            record={this.props.record}
            resource={this.props.resource}
          >
            <FiltersTab record={this.props.record} />
          </CustomFormTab>
          <CustomFormTab
            basePath={this.props.basePath}
            label={<> Flights <FlightsData values={this.props.formValues} /> </>}
            record={this.props.record}
            resource={this.props.resource}
          >
            <FlightsTab record={this.props.record} />
          </CustomFormTab>
          <CustomFormTab
            basePath={this.props.basePath}
            label={<> User Freq Caps <UserFreqCapsData values={this.props.formValues} /> </>}
            record={this.props.record}
            resource={this.props.resource}
          >
            <UserFreqCap record={this.props.record} />
          </CustomFormTab>
        </TabbedForm>
      </Edit>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    formValues: getFormValues('record-form')(state)
  }
}

export default connect(mapStateToProps)(CampaignPmpEdit);



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Pmp/Edit.tsx